import { UserWithGroupAuth } from 'requests/RequestGroup';

export const GroupAuth = {
	ADMIN: { key: 1, name: '代表者', image: 'Admin.png' },
	USER: { key: 2, name: '一般', image: 'User.png' },
	MEMBER: { key: 99, name: 'こどもID', image: 'smile.svg' },
} as const;
export type GroupAuthType = typeof GroupAuth[keyof typeof GroupAuth];

export const findGroupAuthByKey = (user: UserWithGroupAuth) => {
	if (user.member_flg === 1) {
		return GroupAuth.MEMBER;
	}
	const auth = Object.values(GroupAuth).find((p) => p.key === user.group_auth);
	return auth;
};

export const isAdmin = (type: GroupAuthType) => {
	return GroupAuth.ADMIN.key === type.key;
};
export const isUser = (type: GroupAuthType) => {
	return GroupAuth.USER.key === type.key;
};
export const isMember = (type: GroupAuthType) => {
	return GroupAuth.MEMBER.key === type.key;
};
